<template>
  <div>
    <el-card class="box-card">
            <div class="text item">
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form :inline="true" class="demo-form-inline" size="small"
                                style="text-align: left;margin-top:5px;height:30px" ref="Searchform" :model="Search">
                                <el-form-item label="真实姓名" prop="jpName">
                                    <el-input v-model="Search.jpName" placeholder="请输入真实姓名" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="手机号" prop="jpPhone">
                                    <el-input v-model="Search.jpPhone" placeholder="请输入用户手机号码" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="审核状态" prop="status">
                                    <el-select v-model="Search.status" placeholder="请选择审核状态" clearable>
                                        <el-option v-for="item in status_options" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="所属团队" prop="jobParentId">
                                    <el-select 
                                        v-model="Search.jobParentId" 
                                        filterable 
                                        remote 
                                        reserve-keyword
                                        placeholder="请输入团队名称" 
                                        clearable
                                        :remote-method="getTeamList" 
                                        :loading="team_loading"
                                        @focus="handleTeamFocus">
                                        <el-option 
                                            v-for="item in team_options" 
                                            :key="item.campusUserId" 
                                            :label="item.jobName"
                                            :value="item.campusUserId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button icon="el-icon-search" type="primary" size="mini"
                                        @click="handleSearch()">查询</el-button>
                                    <el-button icon="el-icon-refresh" size="mini" @click="ClearSearchform()">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple-light">
                            <el-table 
                                :data="tableData_campus_job" 
                                border 
                                style="width: 100%"
                                max-height="600"
                                v-loading="loading"
                                element-loading-text="加载中..."
                                :default-sort="{ prop: 'createTime', order: 'descending' }">
                                <el-table-column prop="jobName" label="真实姓名" width="110">
                                </el-table-column>
                                <el-table-column prop="jobPhone" label="手机号码" width="120">
                                </el-table-column>
                                
                                <el-table-column prop="studentPapers" label="学生证" width="100" align="center">
                                    <template slot-scope="scope">
                                        <el-image style="height:50px" mode="heightFix"
                                            :preview-src-list="[scope.row.studentPapers]" :src="scope.row.studentPapers"
                                            ></el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="idCard" label="身份证" width="100" align="center">
                                    <template slot-scope="scope">
                                        <el-image style="height:50px" mode="heightFix"
                                            :preview-src-list="[scope.row.idCard]" :src="scope.row.idCard"
                                            ></el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="schoolName" label="所属学校" min-width="150" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="jobType" label="申请类型" width="100" align="center">
                                    <template slot-scope="scope">
                                        <el-tag v-if="scope.row.jobType == 'C'&&scope.row.status!='3'" size="small">兼职</el-tag>
                                        <el-tag v-if="scope.row.jobType == 'C'&&scope.row.status=='3'" size="small">负责人</el-tag>
                                        <el-tag v-if="scope.row.jobType == 'F'" type="warning" size="small">负责人</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="jobParentName" label="所属团队" width="120" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.jobParentId != 0">{{ scope.row.jobParentName }}</span>
                                        <span v-else style="color: #999;">无</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="createTime" label="申请时间" width="180" sortable>
                                    <template slot-scope="scope">
                                        <i class="el-icon-time"></i>
                                        <span style="margin-left: 10px">{{ scope.row.createTime | dateFormat }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="status" label="审核状态" width="100" align="center">
                                    <template slot-scope="scope">
                                        <el-tag v-if="scope.row.status == '0'" type="danger" size="small">未处理</el-tag>
                                        <el-tag v-if="scope.row.status == '1'" type="success" size="small">已通过</el-tag>
                                        <el-tag v-if="scope.row.status == '2'" type="warning" size="small">已禁用</el-tag>
                                        <el-tag v-if="scope.row.status == '3'" type="success" size="small">兼职提交</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="180" align="center" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="success" icon="el-icon-check" size="mini" v-if="scope.row.status == '3'||scope.row.status == '0'"
                                            @click="toUpdate(scope.row)">通过</el-button>
                                        <el-button type="danger" icon="el-icon-close" size="mini" v-if="scope.row.status == '3'||scope.row.status == '0'"
                                            @click="toDelete(scope.row)">驳回</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 20px;">
                    <el-col :span="24">
                        <div style="text-align: center;">
                            <el-pagination 
                                v-if="tableData_campus_job.length != 0"
                                background 
                                layout="total, prev, pager, next, jumper" 
                                :total="total" 
                                :current-page.sync="queryObj.page"
                                :page-size="queryObj.limit"
                                @current-change="handleCurrentChange">
                            </el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-card>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
        status_options:[
        {
                value: '1',
                label: '已通过'
            },{
                value: '2',
                label: '已禁用'
            },{
                value: '0',
                label: '未处理'
            },{
                value: '3',
                label: '未处理（兼职申请负责人）'
            },
        ],//审核状态下拉筛选
        Search:{//搜索内容
            jpName:'',
            jpPhone:'',
            status:'',
            jobParentId:''
        },
        team_options:[],//所属团队下拉列表
        team_loading: false,//团队搜索加载状态
        tableData_campus_job:[],//表格数据(兼职审核)
        total: 0,//总数据条数
        loading: false,//加载状态
        queryObj: {//分页渲染条件
                limit: 8,//行
                page: 1,//页数
                query: "",//条件
            },
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 点击通过
    toUpdate(Data) {
        console.log(Data)
            this.$confirm('确定通过？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const { data: res } = await this.$http.post('campusjob/passCompusJob', Data);
                if (res.code == 200) {
                    this.$message({ type: "success", message: "通过成功!" })
                    this.getCampusJobList()
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消通过'
                })
            })
        },
    // 点击驳回
    toDelete(Data) {
            this.$confirm('确定驳回？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const { data: res } = await this.$http.post('campusjob/delCompusJob', Data);
                if (res.code == 200) {
                    this.$message({ type: "success", message: "驳回成功!" })
                    this.getCampusJobList()
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消驳回'
                })
            })
        },
    //分页交互调用事件
    handleCurrentChange(newPage) {
            this.queryObj.page = newPage;
            this.getCampusJobList();
        },
    // 查询按钮点击事件
    handleSearch() {
        this.queryObj.page = 1; // 重置到第一页
        this.getCampusJobList();
    },
    // 重置搜索表单
    ClearSearchform() {
        console.log("重置搜索表单");
        // 手动清空搜索条件
        this.Search = {
            jpName: '',
            jpPhone: '',
            status: '',
            jobParentId: ''
        };
        this.team_options = []; // 清空团队选项
        this.queryObj.page = 1; // 重置到第一页
        this.getCampusJobList(); // 重新加载数据
    },
    // 团队选择框获得焦点时加载初始数据
    handleTeamFocus() {
        if (this.team_options.length === 0) {
            this.getTeamList('');
        }
    },
    // 获取团队列表（远程搜索）
    async getTeamList(query) {
        this.team_loading = true;
        try {
            const { data: res } = await this.$http.get('/campusjob/getTeamByJobName', {
                params: { 
                    jobName: query || ''
                }
            });
            console.log('🔍 团队下拉列表数据:', res);
            if (res.code === 200 && res.data) {
                this.team_options = res.data || [];
                console.log('✅ 成功加载', this.team_options.length, '个团队');
            } else {
                this.team_options = [];
                console.warn('⚠️ 获取团队列表返回异常:', res.msg);
            }
        } catch (error) {
            console.error('❌ 获取团队列表失败:', error);
            this.$message.error('获取团队列表失败');
            this.team_options = [];
        } finally {
            this.team_loading = false;
        }
    },
    // 重新渲染表格
        // 渲染表格数据(动态)数据
        async getCampusJobList() {
            try {
                this.loading = true; // 开启加载状态
                
                // 构建 POST 请求的 Body（ReqJobDto 格式）
                const requestBody = {
                    pageNum: this.queryObj.page,
                    pageSize: this.queryObj.limit
                };
                
                // 只添加非空的搜索条件（使用 jpName, jpPhone, status, jobParentId 字段）
                if (this.Search.jpName && this.Search.jpName.trim()) {
                    requestBody.jpName = this.Search.jpName.trim();
                }
                if (this.Search.jpPhone && this.Search.jpPhone.trim()) {
                    requestBody.jpPhone = this.Search.jpPhone.trim();
                }
                if (this.Search.status && this.Search.status !== '') {
                    requestBody.status = this.Search.status;
                }
                // 添加团队筛选条件（注意：jobParentId 可能为 0，所以要特别处理）
                if (this.Search.jobParentId !== '' && this.Search.jobParentId !== null && this.Search.jobParentId !== undefined) {
                    requestBody.jobParentId = this.Search.jobParentId;
                    console.log('✅ 已添加团队筛选条件，jobParentId:', this.Search.jobParentId);
                }
                
                console.log('===== 查询参数 =====');
                console.log('搜索条件对象:', this.Search);
                console.log('POST 请求体:', requestBody);
                
                const { data: res } = await this.$http.post('/campusjob/getCampusJobList', requestBody);
                
                console.log('===== 接口返回 =====');
                console.log('完整响应:', res);
                console.log('数据条数:', res.data ? res.data.total : 0);
                
                if (res.code === 200 && res.data) {
                    this.tableData_campus_job = res.data.children || [];
                    this.total = res.data.total || 0;
                    
                    if (this.total === 0) {
                        this.$message.info('未查询到符合条件的数据');
                    } else {
                        console.log('✅ 加载成功，共', this.total, '条数据');
                    }
                } else {
                    console.warn('⚠️ 接口返回异常:', res.msg);
                    this.$message.error('查询失败：' + (res.msg || '未知错误'));
                    this.tableData_campus_job = [];
                    this.total = 0;
                }
            } catch (error) {
                console.error('❌ 加载数据失败:', error);
                console.error('错误详情:', error.response || error.message);
                this.$message.error('加载数据失败，请重试');
                this.tableData_campus_job = [];
                this.total = 0;
            } finally {
                this.loading = false; // 关闭加载状态
            }
        },
  },
  created() {},
  mounted() {
    this.getCampusJobList()
  }
};
</script>
<style lang="scss" scoped>

.box-card {
    width: 100%;
}

.item {
    margin-bottom: 18px;
}

.grid-content {
    margin: 20px 0;
}
</style>
</style>